import { render, staticRenderFns } from "./AppRecommendedProductsSlider.vue?vue&type=template&id=2f415b9a&scoped=true"
import script from "./AppRecommendedProductsSlider.vue?vue&type=script&lang=ts"
export * from "./AppRecommendedProductsSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f415b9a",
  null
  
)

export default component.exports